import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useBoolean } from '@conxai/react-kit';
import { EditIcon } from '@shared/ui/icons/EditIcon';
import { EditProjectDialog } from '../EditProjectDialog';
export function EditProjectButton() {
    const [isEditProjectDialogOpen, , showEditProjectDialog, hideEditProjectDialog] = useBoolean(false);
    return (_jsxs(_Fragment, { children: [_jsx("div", { style: { cursor: 'pointer' }, onClick: showEditProjectDialog, children: _jsx(EditIcon, {}) }), isEditProjectDialogOpen && _jsx(EditProjectDialog, { onClose: hideEditProjectDialog })] }));
}
